import { gql } from '@apollo/client';
import { welfareOfficeBaseData } from 'services/query/welfareOffices';

export const CREATE_WELFARE_OFFICE = gql`
  mutation createWelfareOffice($data: WelfareOfficeCreateInput!) {
    createWelfareOffice(data: $data) {
      id
    }
  }
`;

export const UPDATE_WELFARE_OFFICE = gql`
  mutation updateWelfareOffice($id: ID!, $data: WelfareOfficeUpdateInput!) {
    updateWelfareOffice(id: $id, data: $data) {
      ${welfareOfficeBaseData}
      dispatchEmail
    }
  }
`;

export const DELETE_WELFARE_OFFICE = gql`
  mutation deleteWelfareOffice($id: ID!) {
    deleteWelfareOffice(id: $id)
  }
`;
